import { configureStore } from '@reduxjs/toolkit';
import ratesSlice from "./rates.slice";
import feesSlice from "./fees.slice";
import facilitiesSlice from "./facilities.slice";
import accessDevicesSlice from "./accessDevices.slice";
import surveyQuestionsSlice from "./surveyQuestions.slice";
import billingProfileSlice from "./billingProfiles.slice"

import {
    accessDevicesKey,
    apiKey,
    billingProfileKey,
    facilitiesKey,
    feesKey,
    purchaseKey,
    ratesKey,
    surveyQuestionsKey,
} from "./entities";
import purchaseSlice from "./purchase.slice";
import apiSlice from './api.slice';
const store = configureStore({
    reducer: {
        [apiKey]: apiSlice,
        [feesKey]: feesSlice,
        [ratesKey]: ratesSlice,
        [facilitiesKey]: facilitiesSlice,
        [accessDevicesKey]: accessDevicesSlice,
        [surveyQuestionsKey]: surveyQuestionsSlice,
        [billingProfileKey]: billingProfileSlice,
        [purchaseKey]: purchaseSlice,
    }
});
export default store;
